import type { ImageLoaderProps } from 'next/image'

// Docs: https://www.sanity.io/docs/image-urls
export default function sanityLoader({ src, quality }: ImageLoaderProps) {
  const url = new URL(src)
  url.searchParams.set('auto', 'format')
  url.searchParams.set('fit', 'max')
  if (quality) {
    url.searchParams.set('q', quality.toString())
  }
  return url.href
}
